import { useAuthStore } from '@/modules/auth/store/auth';
import { storeToRefs } from 'pinia';

export default defineNuxtRouteMiddleware((to, from) => {
  const { hasLoggedInUser } = storeToRefs(useAuthStore());

  if (!hasLoggedInUser.value) {
    return navigateTo('/login');
  }

  return navigateTo('/company-wellbeing');
});
